import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatIcon } from '@angular/material/icon'
import { Router } from '@angular/router'
import { Title } from '@angular/platform-browser'

import { ButtonComponent } from '../../components/button/button.component'
import { UserStore } from '../../stores/user.store'
import { getTitle } from '../../util/accessibility'
import { tap } from 'rxjs'

@Component({
  selector: 'app-forgot-password-page',
  standalone: true,
  imports: [ButtonComponent, MatIcon, ReactiveFormsModule],
  templateUrl: './forgot-password-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './forgot-password-page.component.scss',
})
export class ForgotPasswordPageComponent implements OnInit {
  hasSent = false
  message: string | null = null

  email = new FormControl('', {
    nonNullable: true,
    validators: [Validators.required, Validators.email],
  })

  resetPasswordForm = new FormGroup({
    email: this.email,
  })

  constructor(
    private router: Router,
    private userStore: UserStore,
    private titleService: Title,
  ) {
    this.titleService.setTitle(getTitle('パスワードの再設定'))
  }

  ngOnInit(): void {
    const navigation = this.router.lastSuccessfulNavigation()
    if (navigation?.extras?.state) {
      this.message = navigation.extras.state.message
    }
  }

  backToLogin() {
    this.router.navigate(['/login'])
  }

  sendPasswordResetEmailSubmit = (event: Event) => {
    event.preventDefault()

    this.userStore
      .resetPassword(this.email.value)
      .pipe(
        tap((result) => {
          if (result?.success) {
            this.hasSent = true
          } else {
            let errorMessage = ''
            if (result?.code === 'INVALID_EMAIL_FORMAT') {
              errorMessage = 'メールアドレスの形式が正しくありません。'
            } else {
              errorMessage = `エラーが発生しました。コード: ${result?.code}`
            }
            alert(errorMessage)
          }
        }),
      )
      .subscribe()
  }
}
